import React from "react";
import {useSelector} from "react-redux";

export const AddressList = ({cartId, billingAddresses}) => {
  const {shippingAddresses, shippingAddressesLoading, shippingAddressesError} = useSelector(
    state => ({
      shippingAddresses: state.shippingReducer.payload.shippingAddresses || [],
      shippingAddressesLoading: state.shippingReducer.shippingAddressesLoading,
      shippingAddressesError: state.shippingReducer.shippingAddressesError
    })
  );

  const deliveryAddresses = [];
  if (shippingAddressesLoading) {
    deliveryAddresses.push(
      <div key="address-loader" className="loader-container">
        <div className="loader"/>
      </div>
    );
  } else if (shippingAddressesError !== null && shippingAddressesError !== undefined) {
    deliveryAddresses.push(
      <div key="address-error" className="bootstrap"><p
        className="text-danger mb-3">{window.trans('front.order.checkout.shipping_step.withdrawal.error.internal', {
        '{{ cart_id }}': cartId
      })}</p></div>
    );
  } else {
    shippingAddresses.forEach((address, index) => {
      deliveryAddresses.push(<Address key={index} address={address}
                                      label={window.trans('front.javascript.address.delivery.label')}/>);
    });
  }

  return (
    <div>
      {deliveryAddresses}
      {billingAddresses !== undefined && billingAddresses.map((address, index) => {
        return <Address key={index} address={address} label={window.trans('front.javascript.address.billing.label')}/>
      })}
    </div>
  );
};

const Address = ({address, label}) => (
  <div className="bootstrap card">
    <span className="text-orange">{label}</span><br/>
    <p className="text-muted">
      {address.fullName ? address.fullName : ''}{address.fullName ? <br/> : ''}
      {address.street}<br/>
      {address.postCode}, {address.city}
    </p>
  </div>
);
